<div class="card" style="overflow-x: auto;">
	<ng-container *ngIf="loading">
		<p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
		<div class="p-text-center p-mt-3">{{ translateServ.dictionary['LOADING_HISTORY'] }}...</div>
	</ng-container>

	<ng-container *ngIf="!loading && errorMessage">
		<div class="flex flex-column align-items-center justify-content-center h-20rem p-5">
			<div class="p-message p-message-error p-message-icon text-center"
				style="margin-bottom: 1rem; padding: 2rem; border-radius: var(--border-radius); width: 100%;">
				<i class="pi pi-times-circle text-6xl mb-3"></i>
				<div class="font-bold text-xl mb-3">{{ errorMessage }}</div>
				<button pButton type="button" icon="pi pi-refresh" label="Retry" (click)="loadRecords()"
					class="p-button-raised p-button-danger"></button>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="!loading && !errorMessage">
		<div class="flex align-items-center justify-content-between p-mb-3">
			<h5 class="m-0">{{ translateServ.dictionary['ITEM_MOVIN_HIST'] }}</h5>
			<div class="p-input-icon-left"
				[ngClass]="(directionServ.currentDirection$ | async) === 'ltr' ? 'ml-auto' : 'mr-auto'">
				<i class="pi pi-search"></i>
				<input pInputText type="text" placeholder="{{ translateServ.dictionary['SEARCH'] }}..."
					(input)="applyFilter($event)" />
			</div>
		</div>

		<p-table #dt id='tab_mov_main' styleClass="app-data-table app-data-table--paged" [value]="records" [paginator]="true" [totalRecords]="records.length"
			[rows]="getCurrentPageSize(0,records.length)" [responsiveLayout]="'scroll'"
			[rowsPerPageOptions]="setPaginator(records.length)" (onPage)="onRowsPerPageChange($event,0,records.length)"
			[paginatorDropdownAppendTo]="'body'" [tableStyle]="{'min-width': '800px'}" dataKey="MoveIn_ExportRecID"
			[globalFilterFields]="globalFilterFields">

			<ng-template pTemplate="header">
				<tr>
					<th style="width:3rem"></th>
					<th pSortableColumn="MoveIn_ExportRecID">{{ translateServ.dictionary['JMT_COL_ID'] }}<p-sortIcon
							field="MoveIn_ExportRecID"></p-sortIcon></th>
					<th pSortableColumn="DoseRecID">{{ translateServ.dictionary['MAINT_CS_TIT_DOSE_RECID'] }}<p-sortIcon
							field="DoseRecID"></p-sortIcon></th>
					<th pSortableColumn="Dose">{{ translateServ.dictionary['MAINT_CS_TIT_DOSE'] }} <p-sortIcon
							field="Dose"></p-sortIcon></th>
					<th pSortableColumn="UserName">{{ translateServ.dictionary['MAINT_CS_TIT_PREF_BY'] }} <p-sortIcon
							field="UserName"></p-sortIcon></th>
					<th pSortableColumn="RoleName">{{ translateServ.dictionary['MAINT_CS_TIT_ROLE'] }} <p-sortIcon
							field="RoleName"></p-sortIcon></th>
					<th pSortableColumn="MoveInCreateDate">{{ translateServ.dictionary['MAINT_CS_TIT_CREATED_ON'] }}
						<p-sortIcon field="MoveInCreateDate"></p-sortIcon>
					</th>
					<th style="width:6rem; text-align:center">{{ translateServ.dictionary['STEP_TAB_TIT_ACT'] }}</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-row>
				<tr>
					<td>
						<button type="button" class="p-button p-button-text p-button-sm p-button-rounded"
							(click)="toggleRow(row)" [title]="isRowExpanded(row) ? 'Collapse' : 'Expand'">
							<i class="pi" [ngClass]="isRowExpanded(row) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
						</button>
					</td>
					<td>
						<span class="inline-flex align-items-center gap-2">
							<span>{{ row.MoveIn_ExportRecID }}</span>
							<span *ngIf="row.IsTmpMoveIn" pTooltip="{{this.translateServ.dictionary['SIMULATION']}}" tooltipPosition="top">
								<i class="pi pi-sliders-h"></i>
							</span>
						</span>
					</td>
					<td>{{ row.DoseRecID }}</td>
					<td>{{ row.Dose }}</td>
					<td>{{ row.UserName || '-' }}</td>
					<td>{{ row.RoleName || '-' }}</td>
					<td>{{ row.MoveInCreateDate | date:'dd/MM/yyyy' }}</td>
					<td style="text-align:center">
						<button pButton type="button" icon="pi pi-download" class="p-button-text p-button-sm"
							(click)="download(row)" title="Download"></button>
					</td>
				</tr>
				<tr *ngIf="isRowExpanded(row)">
					<td colspan="8" class="app-expanded-table-cell movein-details-cell">
						<ng-container *ngIf="additionalLoadingByDose[row.DoseRecID]">
							<p-progressBar mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>
						</ng-container>

						<ng-container
							*ngIf="!additionalLoadingByDose[row.DoseRecID] && additionalErrorByDose[row.DoseRecID]">
							<div class="p-message p-message-error p-3">{{ additionalErrorByDose[row.DoseRecID] }}</div>
						</ng-container>

						<ng-container
							*ngIf="!additionalLoadingByDose[row.DoseRecID] && !additionalErrorByDose[row.DoseRecID]">
							<p-table #detailDt id="tab_mov_data" [value]="additionalDataByDose[row.DoseRecID] || []"
								[paginator]="true" [totalRecords]="additionalDataByDose[row.DoseRecID].length"
								[rows]="getCurrentPageSize(1, additionalDataByDose[row.DoseRecID].length)"
								[rowsPerPageOptions]="setPaginator(additionalDataByDose[row.DoseRecID].length)"
								(onPage)="onRowsPerPageChange($event, 1, additionalDataByDose[row.DoseRecID].length)"
								[paginatorDropdownAppendTo]="'body'" [responsiveLayout]="'scroll'"
								[tableStyle]="{'min-width': '900px'}" styleClass="app-data-table app-data-table--compact app-data-table--paged p-datatable-sm movein-details-table"
								[globalFilterFields]="['MoveInLinesRecID', 'FileRecID', 'JornalID', 'Line']"
								[filterDelay]="0">
								<ng-template pTemplate="caption">
									<div class="movein-details-toolbar">
										<button pButton type="button" icon="pi pi-filter-slash"
											label="{{ translateServ.dictionary['BTN_REMOVE_ALL_FILTERS'] || 'Clear filters' }}"
											class="p-button-sm p-button-outlined" (click)="detailDt.clear()"></button>
										<span class="p-input-icon-left">
											<i class="pi pi-search"></i>
											<input pInputText type="text"
												placeholder="{{ translateServ.dictionary['SEARCH'] }}..."
												(input)="detailDt.filterGlobal($any($event.target).value, 'contains')" />
										</span>
									</div>
								</ng-template>
								<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="MoveInLinesRecID" class="movein-details-center-col">
						{{ translateServ.dictionary['JMT_COL_ID'] }} <p-sortIcon field="MoveInLinesRecID"></p-sortIcon>
						<p-columnFilter type="numeric" field="MoveInLinesRecID" display="menu"></p-columnFilter>
					</th>
					<th pSortableColumn="FileRecID" class="movein-details-center-col">
						{{ translateServ.dictionary['doc_num'] }} <p-sortIcon field="FileRecID"></p-sortIcon>
						<p-columnFilter type="numeric" field="FileRecID" display="menu"></p-columnFilter>
					</th>
					<th pSortableColumn="JornalID" class="movein-details-center-col">
						{{ translateServ.dictionary['JOURNAL_MOVES_TITLE'] }} <p-sortIcon field="JornalID"></p-sortIcon>
						<p-columnFilter type="numeric" field="JornalID" display="menu"></p-columnFilter>
					</th>
					<th pSortableColumn="Line">
						{{ translateServ.dictionary['JOURNAL_MOVES_PREVIEW_TITLE'] }} <p-sortIcon
							field="Line"></p-sortIcon>
						<p-columnFilter type="text" field="Line" display="menu"></p-columnFilter>
					</th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-detail>
				<tr>
					<td class="movein-details-center-col">{{ detail.MoveInLinesRecID }}</td>
					<td class="movein-details-center-col">{{ detail.FileRecID }}</td>
					<td class="movein-details-center-col">{{ detail.JornalID }}</td>
					<td class="movein-line-cell">
						<div class="movein-line-toolbar">
							<span>#{{ detail.LineNumber }}</span>
							<button pButton type="button" icon="pi pi-copy" class="p-button-text p-button-sm"
								(click)="copyLine(detail.Line)" title="Copy line"></button>
						</div>
						<pre class="movein-line-preview">{{ detail.Line }}</pre>
					</td>
				</tr>
			</ng-template>

			<ng-template pTemplate="emptymessage">
				<tr>
					<td [attr.colspan]="4">{{ translateServ.dictionary['NOT_FOUND'] }}...</td>
				</tr>
			</ng-template>

			<ng-template let-item pTemplate="paginatordropdownitem">
				{{ item.value === additionalDataByDose[row.DoseRecID].length ? 'All' : item.value }}
			</ng-template>
		</p-table>
	</ng-container>
	</td>
	</tr>
	</ng-template>

	<ng-template pTemplate="emptymessage">
		<tr>
			<td [attr.colspan]="8">{{ translateServ.dictionary['NOT_FOUND'] }}...</td>
		</tr>
	</ng-template>

	</p-table>
	<ng-template let-item pTemplate="paginatordropdownitem">
		{{ item.value === records.length ? 'All' : item.value }}
	</ng-template>
	</ng-container>
</div>